import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=9b7329ba&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=ts"
export * from "./Inventory.vue?vue&type=script&lang=ts"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=9b7329ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7329ba",
  null
  
)

export default component.exports